import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { KeyRound, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { resetPassword } from "../lib/adminApi";
import Logo from "../components/Logo";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Le mot de passe doit contenir au moins 6 caractères");
    if (password !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Lien invalide ou expiré");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-reset-page" className="min-h-screen flex items-center justify-center bg-navy px-5">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <Logo className="h-10 w-10" light />
          <span className="font-display font-bold text-xl text-white">TIRERA GROUP</span>
        </div>
        <form onSubmit={submit} data-testid="admin-reset-form" className="rounded-3xl border border-white/10 bg-white/[0.04] p-8">
          <div className="flex items-center gap-2 text-white/60 text-xs font-semibold uppercase tracking-wider">
            <KeyRound size={14} /> Nouveau mot de passe
          </div>
          <h1 className="mt-3 font-display font-semibold text-2xl text-white">Réinitialisation</h1>
          {!token && <p className="mt-2 text-sm text-red-300">Lien invalide : jeton manquant.</p>}
          <label className="mt-6 block text-sm font-medium text-white/80">Nouveau mot de passe</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-reset-password"
            className="mt-2 w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder-white/40 outline-none focus:border-white/40"
            placeholder="••••••••"
          />
          <label className="mt-4 block text-sm font-medium text-white/80">Confirmer le mot de passe</label>
          <input
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="admin-reset-confirm"
            className="mt-2 w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder-white/40 outline-none focus:border-white/40"
            placeholder="••••••••"
          />
          <button
            type="submit"
            disabled={loading || !token}
            data-testid="admin-reset-submit"
            className="mt-6 w-full rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-navy hover:bg-white/90 transition-colors disabled:opacity-60"
          >
            {loading ? "Enregistrement…" : "Réinitialiser le mot de passe"}
          </button>
          <Link to="/admin/login" className="mt-4 flex items-center justify-center gap-2 text-sm text-white/60 hover:text-white">
            <ArrowLeft size={15} /> Retour à la connexion
          </Link>
        </form>
      </div>
    </main>
  );
}
